import Checkbox, { CheckboxProps } from '@storeblocks/checkbox-atom';
import { Checkboxes } from '@storeblocks/checkboxes';
import { type FC } from 'react';
import styled from 'styled-components';

import { Divider } from '@/components/Divider';
import { useTexts } from '@/hooks/useTexts';
import { presentationScreenRoutes } from '@/routes/presentationScreenRoutes';

import { usePresentationContext } from './PresentationContext';
import { getScreenTitle } from './utils/getScreenTitle';

export const ScreenCheckboxes: FC = () => {
  const texts = useTexts();

  const { selectedScreens, setSelectedScreens } = usePresentationContext();

  const options: CheckboxProps[] = presentationScreenRoutes.map<CheckboxProps>(
    (route) => ({
      id: route.id!,
      value: route.id!,
      label: getScreenTitle(texts, route.id!),
      checked: selectedScreens.some((screen) => screen.id === route.id!),
    }),
  );

  const handleSelectAllChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    if (event.target.checked) {
      setSelectedScreens(presentationScreenRoutes);
    } else {
      setSelectedScreens([]);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSelectedScreens((selected) => {
      if (event.target.checked) {
        const selectedRoute = presentationScreenRoutes.find((route) => {
          return event.target.value === route.id;
        })!;

        return [...selected, selectedRoute];
      }
      return selected.filter((route) => route.id !== event.target.value);
    });
  };

  return (
    <>
      <StyledCheckbox
        id="select-all-screens"
        aria-label="Select all screens"
        name="select-all-screens"
        label={texts.pages.presentation.selectAll}
        onChange={handleSelectAllChange}
        checked={presentationScreenRoutes.length === selectedScreens.length}
      />
      <Divider margin="8" />
      <Checkboxes
        groupName="choose-screens"
        onChange={handleChange}
        options={options}
      />
      <div className="font-details">
        {texts.pages.presentation.chooseElements.description}
      </div>
    </>
  );
};

const StyledCheckbox = styled(Checkbox)`
  font-weight: 600;
`;
